import { quickEntries } from "@/mocks/home";

const toneMap = {
  primary: { icon: "bg-primary-500 text-background-50" },
  accent: { icon: "bg-accent-500 text-foreground-950" },
  secondary: { icon: "bg-secondary-500 text-background-50" },
} as const;

export default function QuickEntries() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-3 px-4 py-5 sm:grid-cols-3 lg:grid-cols-6 md:px-6">
        {quickEntries.map((entry) => (
          <a
            key={entry.name}
            href={entry.href}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-xl ${toneMap[entry.tone].icon}`}
            >
              <i className={entry.icon}></i>
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-950">
                {entry.name}
              </span>
              <span className="block truncate text-xs text-foreground-600">{entry.desc}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}